var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "id-wallet-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.3129 8.46265H6.68704C5.40988 8.46265 4.37454 9.49799 4.37454 10.7751V26.2249C4.37454 27.502 5.40988 28.5374 6.68704 28.5374H30.3129C31.5901 28.5374 32.6254 27.502 32.6254 26.2249V10.7751C32.6254 9.49799 31.5901 8.46265 30.3129 8.46265Z",
    stroke: "#6D0185",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.4373 19.3093C12.9542 19.3093 14.1839 18.0796 14.1839 16.5627C14.1839 15.0457 12.9542 13.816 11.4373 13.816C9.92038 13.816 8.69067 15.0457 8.69067 16.5627C8.69067 18.0796 9.92038 19.3093 11.4373 19.3093Z",
    stroke: "#6D0185",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.96086 23.9686H15.5023C15.6381 23.9688 15.771 23.93 15.8854 23.8569C15.9997 23.7838 16.0907 23.6793 16.1475 23.556C16.2043 23.4327 16.2244 23.2957 16.2056 23.1612C16.1868 23.0268 16.1298 22.9006 16.0414 22.7976C15.5234 22.1527 14.8672 21.6323 14.1213 21.2748C13.3754 20.9172 12.5588 20.7316 11.7316 20.7316C10.9044 20.7316 10.0878 20.9172 9.34186 21.2748C8.59596 21.6323 7.9398 22.1527 7.42174 22.7976C7.33333 22.9006 7.27633 23.0268 7.25754 23.1612C7.23874 23.2957 7.25892 23.4327 7.31569 23.556C7.37246 23.6793 7.46343 23.7838 7.57779 23.8569C7.69216 23.93 7.82511 23.9688 7.96086 23.9686Z",
    stroke: "#6D0185",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.1295 16.0721H27.5246",
    stroke: "#6D0185",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.1295 21.3691H27.5246",
    stroke: "#6D0185",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1295 18.7207H29.5846",
    stroke: "#6D0185",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobId);
export default __webpack_public_path__ + "static/media/jobId.ac276f6bb6dc67ab8399e55a992d182b.svg";
export { ForwardRef as ReactComponent };